import React, { useEffect, useState, useMemo } from "react";
import { motion } from "framer-motion";
import { api } from "../lib/config";
import TripCard from "../components/TripCard";
import PrivateTripBanner from "../components/PrivateTripBanner";
import { Reveal } from "../components/Motion";
import Seo from "../components/Seo";

const MONTHS = ["All", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const TRIP_TYPES = ["All", "Beach", "Culture", "Safari", "Aurora", "Road-trip", "Food", "Adventure"];

export default function Trips() {
  const [trips, setTrips] = useState([]);
  const [month, setMonth] = useState("All");
  const [type, setType] = useState("All");
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/trips", { params: { trip_type: "Group" } }).then((r) => setTrips(r.data)); }, []);

  const filtered = useMemo(() => {
    return trips.filter((t) => {
      if (q && !(`${t.name} ${t.destination} ${t.country}`.toLowerCase().includes(q.toLowerCase()))) return false;
      if (month !== "All") {
        const m = new Date(t.start_date).toLocaleDateString("en-US", { month: "short" });
        if (m !== month) return false;
      }
      if (type !== "All" && !(t.tags || []).includes(type)) return false;
      return true;
    });
  }, [trips, q, month, type]);

  return (
    <div className="pt-28 md:pt-36 pb-16" data-testid="trips-page">
      <Seo
        title="Group Trips"
        description="Browse Once Way Travel's curated small-group journeys — safaris, road trips and once-in-a-lifetime adventures with live seat availability."
        path="/trips"
      />
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <Reveal>
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-owt-muted mb-4">· All Group Trips</div>
          <h1 className="font-display text-6xl md:text-8xl leading-[0.9] text-owt-forest">
            Trips that only<br/><span className="italic text-owt-terracotta">happen once.</span>
          </h1>
        </Reveal>

        {/* filters */}
        <div className="mt-10 md:mt-14 border-y border-owt-border py-6 flex flex-col md:flex-row md:items-center gap-6" data-testid="trip-filters">
          <input
            value={q} onChange={(e)=>setQ(e.target.value)}
            placeholder="Search destination..."
            className="bg-transparent border-b border-owt-border pb-2 outline-none font-mono text-sm text-owt-forest placeholder:text-owt-muted flex-1"
            data-testid="filter-search"
          />
          <div className="flex flex-wrap gap-2">
            {MONTHS.map((m) => (
              <button
                key={m}
                onClick={()=>setMonth(m)}
                data-testid={`filter-month-${m}`}
                className={`font-mono text-[10px] tracking-[0.2em] uppercase px-3 py-1.5 border transition-colors ${month === m ? "bg-owt-forest text-owt-surface border-owt-forest" : "border-owt-border text-owt-forest hover:border-owt-forest"}`}
              >{m}</button>
            ))}
          </div>
        </div>
        <div className="flex flex-wrap gap-2 mt-4">
          {TRIP_TYPES.map((t) => (
            <button
              key={t}
              onClick={()=>setType(t)}
              data-testid={`filter-type-${t}`}
              className={`font-mono text-[10px] tracking-[0.2em] uppercase px-3 py-1.5 border transition-colors ${type === t ? "bg-owt-terracotta text-owt-surface border-owt-terracotta" : "border-owt-border text-owt-forest hover:border-owt-terracotta"}`}
            >{t}</button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mt-12">
          {filtered.map((t, i) => <TripCard key={t.id} trip={t} index={i}/>)}
          {filtered.length === 0 && (
            <div className="col-span-full py-16 text-center text-owt-muted font-mono text-sm tracking-[0.15em] uppercase">No trips match — try clearing filters.</div>
          )}
        </div>
      </div>

      <PrivateTripBanner />
    </div>
  );
}
